const initialState = {
    error: null,
    fetched: false,
    fetching: false,
    submitted: false,
};

const actions = {
    UPDATE_SHELF_FETCH: state => ({...state, fetching: true, error: null}),

    UPDATE_SHELF_FETCH_FULFILLED: (state, {payload}) => ({...state, ...payload}),

    UPDATE_SHELF_FETCH_REJECTED: (state, {payload}) => ({...state, ...payload}),

    REORDER_SHELF_FETCH: state => ({...state, fetching: true, error: null}),

    REORDER_SHELF_FETCH_FULFILLED: (state, {payload}) => ({...state, ...payload}),

    REORDER_SHELF_FETCH_REJECTED: (state, {payload}) => ({...state, ...payload}),

    REMOVE_SHELF_FETCH: state => ({...state, fetching: true, error: null}),

    REMOVE_SHELF_FETCH_FULFILLED: (state, {payload}) => ({...state, ...payload}),

    REMOVE_SHELF_FETCH_REJECTED: (state, {payload}) => ({...state, ...payload}),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
